import React, {useState} from "react"

import {LogoutOutlined} from "@ant-design/icons"
import {message, Modal, Result} from "antd"
import {unbindMerchant} from "../../../api/clubPlatform"
import {useClubPlatformContext} from "../store/useClubPlatformContext"

const ClubPlatformUnbind = ({platformId}) => {
    const [isShow, setIsShow] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    const {getRelationStore} = useClubPlatformContext()

    const handleClick = () => {
        setIsShow(true)
    }

    const handleOk = async () => {
        setIsLoading(true)
        await unbindMerchant(platformId).then(res => {
            if (res.status !== 1) {
                message.error(`解绑商家失败：${res.detail}`)
                return
            }
            message.success("解绑商家成功")
            setIsShow(false)
            getRelationStore()
        }).catch(err => {
            message.error(`解绑商家失败：${err.message}`)
        }).finally(() => {
            setIsLoading(false)
        })
    }

    return (
        <div>
            <div onClick={handleClick}>
                <LogoutOutlined/>
                <span style={{marginLeft: "5px"}}>解绑商家</span>
            </div>
            <Modal
                open={isShow}
                onOk={handleOk}
                onCancel={() => {
                    setIsShow(false)
                }}
                confirmLoading={isLoading}
            >
                <Result title={"确定要解除当前绑定商家吗"} status={"warning"} style={{padding:20}}/>
            </Modal>
        </div>
    )
}

export default ClubPlatformUnbind



// WEBPACK FOOTER //
// ./src/containers/ClubPlatform/component/ClubPlatformUnbind.js